module.exports = __webpack_public_path__ + "static/media/ins.fc1930aa.webp";